/// <amd-module name="NetSuite.LogoList.Common.Utils"/>
define("NetSuite.LogoList.Common.Utils", ["require", "exports", "jQuery"], function (require, exports, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Device;
    (function (Device) {
        Device[Device["phone"] = 0] = "phone";
        Device[Device["tablet"] = 1] = "tablet";
        Device[Device["desktop"] = 2] = "desktop";
    })(Device = exports.Device || (exports.Device = {}));
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.isPhoneDevice = function () {
            return this.getDeviceType() === Device.phone;
        };
        Utils.isTabletDevice = function () {
            return this.getDeviceType() === Device.tablet;
        };
        Utils.isDesktopDevice = function () {
            return this.getDeviceType() === Device.desktop;
        };
        Utils.getDeviceType = function (widthToCheck) {
            var width = widthToCheck || this.getViewportWidth();
            if (width < 768) {
                return Device.phone;
            }
            if (width < 992) {
                return Device.tablet;
            }
            return Device.desktop;
        };
        Utils.getViewportWidth = function () {
            return jQuery(window).width();
        };
        Utils.trim = function (text) {
            return jQuery.trim(text);
        };
        Utils.oldIE = function (version) {
            var ie_version = version || 7;
            // IE7 detection courtesy of Backbone
            // More info: http://www.glennjones.net/2006/02/getattribute-href-bug/
            var isExplorer = /msie [\w.]+/;
            var docMode = document.documentMode;
            return (isExplorer.exec(navigator.userAgent.toLowerCase()) &&
                (!docMode || docMode <= ie_version));
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
